// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_BFc","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_3iD FallbackBulkDownloadUpsellModalControl-cls1_BFc"};